import React, { useState } from "react";
import "./evaluationssummary.scss";

function EvalutionsSummary({ev_id,evalDesc }) {

  return (
    <div className="evalaution-summary-wrapper">
      <div className="resumeDBSearchResults-title">        
        <div className="resumeDBSearchResults-number">
          {evalDesc?.state}
        </div>{" "}
          {evalDesc?.generalsetting.name}
      </div>                
    </div>
  );
}

export default EvalutionsSummary;
